import { DataAnalyticsTaggingEvents, DataAnalyticsTaggingEventType } from '@tdwb/core';

//TODO: use the actual interface/type defined for the below arrays
const securityType: Array<string> = ['equity', 'option', 'strategy', 'mutualfund', 'gic'];
const orderStep: Array<string> = ['edit', 'review', 'complete']

export class TradingAnalytics {

  static tradingOrderTaggingEvents: DataAnalyticsTaggingEvents = this.addTradingOrderEvents();
  static tradingPlatformManagementTaggingEvents: DataAnalyticsTaggingEvents = {
    pageFractional_Landing: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'fractional-landing',
        subSection1: 'trading',
        subSection2: 'fractional-landing',
        customPageName: 'wb_trading-fractional-landing'
      }
    },
    pageFixed_Income: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'fixed-income',
        subSection1: 'page',
        subSection2: 'fixed-income',
        customPageName: 'wb_trading-fixed-income'
      }
    },
    pageNew_Issues: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'new-issues',
        subSection1: 'page',
        subSection2: 'new-issues',
        customPageName: 'wb_trading-new-issues'
      }
    },
    pageAd_EnrollRegistered: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'non-registered',
        subSection1: 'ad-enroll',
        subSection2: 'non-registered',
        customPageName: 'wb_trading-new-issues'
      }
    },
    pageOrder_Status: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'order-status',
        subSection1: 'trading',
        subSection2: 'order-status',
        customPageName: 'wb_trading-order-status'
      }
    },
    pageGic_Landing: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'td-wb-order-entry-gic-landing',
        subSection1: 'trading',
        subSection2: 'buy-sell',
        customPageName: 'wb_trading-gic-landing'
      },
      process: {
        processName: 'tdw:wbt:buy/sell'
      }
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    modalTradingCopy_Edit:{
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'td-wb-order-entry-create-oco-edit',
        subSection1: 'trading',
        subSection2: 'order-status',
        customPageName: 'wb_modal-trading-order-status-copy'
      }
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    modalTradingChange_Order: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'td-wb-order-entry-change-oco-edit',
        subSection1: 'trading',
        subSection2: 'order-status',
        customPageName: 'wb_modal-trading-order-status-change'
      }
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    modalTradingCancel_Confirm: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'td-wb-order-entry-cancel-oco-edit',
        subSection1: 'trading',
        subSection2: 'order-status',
        customPageName: 'wb_modal-trading-order-status-cancel'
      }
    }
  };

  static taggingEvents: DataAnalyticsTaggingEvents =
    { ...this.tradingOrderTaggingEvents,
      ...this.tradingPlatformManagementTaggingEvents
    };

  private static addTradingOrderEvents(): DataAnalyticsTaggingEvents{
    const orderEvents: DataAnalyticsTaggingEvents = {};
    securityType.forEach((security: string)=> {
      orderStep.forEach((step: string)=>{
        const stateKey = `modalTradingOrder${security.charAt(0).toUpperCase()}${security.substring(1)}_${step.charAt(0).toUpperCase()}${step.substring(1)}`;
        const modalName = `td-wb-order-entry-create-${security}-${step}`;
        let customPageName = `wb_trading-${security}-${step}`;
        customPageName = customPageName.replace('-edit', '');
        const processName = 'tdw:wbt:buy/sell';
        let processType = step === 'edit' ? 'start' : 'complete';
        processType = `${processName}:${processType}`;

        orderEvents[stateKey] = {
          event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
          page: {
            modalName,
            subSection1: 'trading',
            subSection2: 'buy-sell',
            customPageName
          },
          process: {
            processName
          }
        };
        if (step === 'edit' || step === 'complete'){
          orderEvents[stateKey].process.processType = processType;
        }
      });
    });
    return orderEvents;
  }

}
